import { useMutation } from "react-query";
import initiateSpv from "../services/initiateSpv";

const useInitiateSpvMutation = () => {
  return useMutation(["initiate-spv"], initiateSpv);
};

export default useInitiateSpvMutation;
